import { useOrdersList } from "../../context/OrderListContext";
import NoData from "@Components/NoData/NoData";
import { DiscountsTransactions, FlightsTransactions, GiftcardTransactions, HotelsTransactions, PointsTransactions } from "../TransactionPages";

export default function OrdersListOutlet() {
  const { selectedTab } = useOrdersList();
  if (selectedTab === "giftcards") return <GiftcardTransactions/>;
  if (selectedTab === "discounts") return <DiscountsTransactions/>;
  if (selectedTab === "points") return <PointsTransactions/>;
  if (selectedTab === "travel") return <FlightsTransactions />;
  if (selectedTab === "hotel") return <HotelsTransactions />;
  if (selectedTab === "topup") return <NoData />;
}
